import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl} from '@angular/forms';
import { DataTable, SelectItem, DropdownModule, DataTableModule, ButtonModule, DialogModule, InputTextModule, MessagesModule, GrowlModule, Message, ConfirmationService, MultiSelectModule, BlockUIModule, SharedModule, Dropdown, InputText} from 'primeng/primeng';
import { IHRBPDetail } from '../../Models/HRBPDetail.model';
import { Page } from '../../Models/pages';
import { SeedDataService } from '../../Services/seeddata.service';
import { HRBPDataService } from '../../Services/hrbp.service';
import { ProfileDataService } from '../../Services/ProfileData';
import { forEach } from '@angular/router/src/utils/collection';


@Component({
    templateUrl: './HRBPDetails.component.html'
})

export class HRBPDetailsComponent implements OnInit
{
    IsDelete: boolean;
    IsSave: boolean;
    IsUserAdmin: boolean;
    id:any;
    synced: boolean;
    hrbpForm: FormGroup;
    details: HRBPDetail[];
    pages: Page[];
    msgs: Message[] = [];
    Label: string;
    MandatoryStar: string;
    displayDialog: boolean;

    hrpbList: SelectItem[];
    departmentList: SelectItem[];
    locationList: SelectItem[];
    deliveryUnitList: SelectItem[];
    clientList: SelectItem[];
    gradeList: SelectItem[];

    projectGroup: string;
    tenureList: SelectItem[];
    employmentStatusList : SelectItem[];

    reviewPermissionList: SelectItem[];
    targetPermissionList: SelectItem[];
    benefitsPermissionList: SelectItem[];
    attendancePermissionList: SelectItem[];
    deliveryUnitchanged: SelectItem[];
    hrbps:any;

    constructor( private route: ActivatedRoute, 
                 private router: Router, 
                 private fb: FormBuilder,
                 private seedDataService: SeedDataService, 
                 private hrbpDataService: HRBPDataService,
                 private profileDataService: ProfileDataService, 
                 private confirmationService: ConfirmationService)
    {
        this.ngOnInit();
        if (JSON.parse(window.localStorage.getItem('pagedetails')) != null) {
            this.pages = JSON.parse(window.localStorage.getItem('pagedetails'));
            if (router.url != '/home') {
                var isValid = false;
                for (var i = 0; i < this.pages.length; i++) {
                    if (this.pages[i].url == router.url) {
                        if (this.pages[i].permissionID == 1) {
                            this.IsDelete = false;
                            this.IsSave = false;
                        }
                        if (this.pages[i].permissionID == 2) {
                            this.IsDelete = false;
                            this.IsSave = true;
                        }
                        if (this.pages[i].permissionID == 3) {

                            this.IsDelete = true;
                            this.IsSave = true;
                        }
                    }
                }
            }
        }
    }
    
    ngOnInit() {

        this.IsUserAdmin = (JSON.parse(window.localStorage.getItem('currentUser')).RoleName == "Admin");
        this.displayDialog = false;
        this.hrbpForm = this.fb.group({
            "HRBPs":["", Validators.required],
            "Department":[""],
            "Location":[""],
            "DeliveryUnit":[""],
            "Client":[""],
            "Grade":[""],

            "ProjectGroup": [""],
            "Tenure": [""],
            "EmploymentStatus": [""],
            "ReviewPermission" : [""],
            "TargetPermission" : [""],
            "BenefitsPermission" : [""],
            "AttendancePermission" : [""]

        });

        
        // 'Instead department take from New Department' changed
        this.seedDataService.getLOVByTypeName("NewDepartment").subscribe((data) => {
            this.departmentList=this.renamePropertyNames(JSON.stringify(data), 'Select Department', null, "dropdown");
        });

        // this.seedDataService.GetDeliveryUnitDataWithoutTreeForm(0).subscribe((deliveryunitList: SelectItem[]) => {
        //     let data = this.renamePropertyNamesCommon(JSON.stringify(deliveryunitList), "Select Delivery Unit");
        //     console.log(data);
        //     this.deliveryUnitList = data;
        // });

        //start: 'Instead from LOV Type Client take from Eagle portal'
        // this.seedDataService.getLOVByTypeName("Client").subscribe((data) => {
        //     this.clientList=this.renamePropertyNames(JSON.stringify(data), 'Select Client', null, "dropdown");
        // });
        this.seedDataService.getClientsByDepartmentID(0).subscribe((clientList: SelectItem[]) => {
            let data = this.renamePropertyNamesClient(JSON.stringify(clientList), "Select Client");
            this.clientList = data;
        });
        //end: 'Instead from LOV Type Client take from Eagle portal'


        this.seedDataService.getLOVByTypeName("Location").subscribe((data) => {
            this.locationList=this.renamePropertyNames(JSON.stringify(data), 'Select Location', null, "dropdown");
        });

        this.seedDataService.getLOVByTypeName("Grade").subscribe((data) => {
            this.gradeList=this.renamePropertyNames(JSON.stringify(data), 'Select Grade', null, "dropdown");
        });

        //start: need to take delivery units from eagle.
        // this.seedDataService.GetAllDeliveryUnits().subscribe((data) => {
        //     this.deliveryUnitList=this.renamePropertyNames(JSON.stringify(data), 'Select Delivery Unit', null, "dropdown");
        // });
        // //Practices is used as Delivery unit in Eagle portal.
        // this.seedDataService.getPracticesByDepartmentID(0).subscribe((practiceList: SelectItem[]) => {
        // this.seedDataService.GetDeliveryUnitDataWithoutTreeForm(0).subscribe((deliveryunitList: SelectItem[]) => {
        //     let data = this.renamePropertyNamesCommon(JSON.stringify(deliveryunitList), "Select Delivery Unit");
        //     this.deliveryUnitList = data;
        // });
        //end: need to take delivery units from eagle.


        this.seedDataService.getPracticesByDepartmentID(0).subscribe((practiceID: SelectItem[]) => {
            let data = this.renamePropertyNamesPractice(JSON.stringify(practiceID), "Select Delivery Unit");
            this.deliveryUnitchanged = data;
        });
        this.seedDataService.GetHRList().subscribe((data) => {
            // this.hrpbList=this.renamePropertyNames(JSON.stringify(data), 'Select HR Manager', null, "multiselect");
            this.hrpbList=this.renamePropertyNames(JSON.stringify(data), 'Select HR Manager', null, "dropdown");
        });

        this.seedDataService.getLOVByTypeName("EmploymentStatus").subscribe((data) => {
            this.employmentStatusList = this.renamePropertyNames(JSON.stringify(data), 'Select Employment Status', null, "dropdown");
        });

        this.seedDataService.getLOVByTypeName("PermissionType").subscribe((permissionType) => {
            let data = this.renamePropertyNames(JSON.stringify(permissionType), '', null, 'dropdown');
            this.reviewPermissionList = data;
            this.attendancePermissionList = data;
            this.benefitsPermissionList = data;
            this.targetPermissionList = data;
        }
        )

        this.tenureList = this.getTenureList(25);

        this.bindHRBPDetailsList();
    }

    getTenureList(limit: number)
    {
        var objddl = [];

        objddl.push({ 'label': 'Select Tenure', 'value': '-1' });
        for (var i = 0; i <= limit; i++) {
                objddl.push({ 'label': i.toString(), 'value': i.toString() });
        }
        return objddl;
    }

    renamePropertyNamesPractice(json: any, _firstOption: any) {
        var obj;
        if (json != null && json != '') {
            obj = JSON.parse(json);
        }

        var objddl = [];
        objddl.push({ 'label': _firstOption, 'value': '' })

        if (obj != null && obj != undefined && obj != '') {
            for (var i = 0; i < obj.length; i++) {
                if (obj[i].hasOwnProperty("Name")) {
                    objddl.push({ 'label': obj[i]["Name"], 'value': obj[i]["practiceID"] });
                }
                if (obj[i].hasOwnProperty("name")) {
                    objddl.push({ 'label': obj[i]["name"], 'value': obj[i]["practiceID"] });
                }

            }
        }
        return objddl;
    }
    renamePropertyNamesCommon(json: any, _firstOption: any) {
        var obj;
        if (json != null && json != '') {
            obj = JSON.parse(json);
        }

        var objddl = [];
        objddl.push({ 'label': _firstOption, 'value': '' })

        if (obj != null && obj != undefined && obj != '') {
            for (var i = 0; i < obj.length; i++) {
                if (obj[i].hasOwnProperty("Name")) {
                    objddl.push({ 'label': obj[i]["Name"], 'value': obj[i]["id"] });
                }
                if (obj[i].hasOwnProperty("name")) {
                    objddl.push({ 'label': obj[i]["name"], 'value': obj[i]["id"] });
                }
            }
        }
        return objddl;
    }

    renamePropertyNamesClient(json: any, _firstOption: any) {
        
        var obj;
        if (json != null && json != '') {
            obj = JSON.parse(json);
        }

        var objddl = [];
        objddl.push({ 'label': _firstOption, 'value': '' })

        if (obj != null && obj != undefined && obj != '') {
            
            for (var i = 0; i < obj.length; i++) {
                if (obj[i].hasOwnProperty("clientName")) {
                    objddl.push({ 'label': obj[i]["clientName"], 'value': obj[i]["clientID"] });
                }
            }
        }
        return objddl;
    }

    onChangeDepartment(event) {
        var departmentID = this.hrbpForm["Department"];
        if (departmentID) {
            this.seedDataService.getClientsByDepartmentID(departmentID).subscribe((clientList: SelectItem[]) => {
                let data = this.renamePropertyNamesClient(JSON.stringify(clientList), "Select Client");
                this.clientList = data;
                this.hrbpForm["TempClient"] = this.hrbpForm["Client"];
            });

            //this.seedDataService.getPracticesByDepartmentID(departmentID).subscribe((practiceList: SelectItem[]) => {
            // this.seedDataService.GetDeliveryUnitDataWithoutTreeForm(0).subscribe((deliveryunitList: SelectItem[]) => {
            //     let data = this.renamePropertyNamesCommon(JSON.stringify(deliveryunitList), "Select Delivery Unit");
            //     this.deliveryUnitList = data;
            //     this.hrbpForm["TempDeliveryUnit"] = this.hrbpForm["DeliveryUnit"];
            // });
        }
        else {
            let data = this.renamePropertyNamesClient('', "Select Client");
            this.clientList = data;

            // data = this.renamePropertyNamesPractice('', 'Select Delivery Unit');
            data = this.renamePropertyNamesCommon('', 'Select Delivery Unit');
            this.deliveryUnitList = data;

        }
    }

    showDialogToAdd() {
        this.id=null;
       this.resetForm();
        this.MandatoryStar = "*"
        this.Label = "Add HR Business Partner Detail";
        this.displayDialog = true;
        this.onChangeDepartment(null);
        this.seedDataService.GetDeliveryUnitDataWithoutTreeForm(0).subscribe((deliveryunitList: SelectItem[]) => {
            let data = this.renamePropertyNamesCommon(JSON.stringify(deliveryunitList), "Select Delivery Unit");
            this.deliveryUnitList = data;
        });
    }
    resetForm()
    {
        this.hrbpForm.controls["Department"]["optionsToDisplay"]=[];
        this.hrbpForm.reset();
    }
    onRowSelect(event: any, data: any)
    {
        this.hrbpDataService.getHRBPDetailsByID(data.id).subscribe((data) => {
            this.id = data.id;
            this.MandatoryStar = "*"
            this.Label = "Update HR Business Partner Detail";
            this.displayDialog = true;
            
            this.hrbpForm["HRBPs"] = data["hrbPs"];
            this.hrbpForm["Department"] = data["department"];
            this.hrbpForm["Location"] = data["location"];
            this.hrbpForm["DeliveryUnit"] = data["deliveryUnit"];
            this.hrbpForm["Client"] = data["client"];
            this.hrbpForm["Grade"] = data["grade"];

            this.hrbpForm["ProjectGroup"] = data["projectGroup"];
            this.hrbpForm["Tenure"]= data["tenure"];
            this.hrbpForm["EmploymentStatus"]= data["employmentStatus"];

            this.hrbpForm["ReviewPermission"] = data["reviewPermission"];
            this.hrbpForm["TargetPermission"] = data["targetPermission"];
            this.hrbpForm["BenefitsPermission"] = data["benefitsPermission"];
            this.hrbpForm["AttendancePermission"] = data["attendancePermission"];

            this.hrbpForm["TempClient"] = this.hrbpForm["Client"];
            this.hrbpForm["TempDeliveryUnit"] = this.hrbpForm["DeliveryUnit"];

            this.onChangeDepartment(null);

        });

    }
    cancel() 
    {
        this.displayDialog = false;
    }
    onSubmit(value: string)
    {

        this.hrbpForm["Client"] = this.hrbpForm["TempClient"] ;
        this.hrbpForm["DeliveryUnit"] = this.hrbpForm["TempDeliveryUnit"];

        if (this.hrbpForm["Tenure"] === undefined || this.hrbpForm["Tenure"]=== null)
        {
            debugger
            this.hrbpForm["Tenure"] = '-1';
        };

        var json = this.hrbpForm.getRawValue();
        json["ID"]=this.id;
        let serializedForm = JSON.stringify(json);
        
        this.hrbpDataService.saveDetail(serializedForm).subscribe((data) => {
            this.msgs = [];
            debugger
            if(data && data.errorMessage)
            {
                this.msgs.push({ severity: 'error', summary: '', detail: data.errorMessage});
            }
            else
            {
                this.cancel();
                this.bindHRBPDetailsList();
                if (this.id && this.id>0) {
                    this.msgs.push({ severity: 'success', summary: '', detail: 'Record updated successfully.' });
                } else {
                    this.msgs.push({ severity: 'success', summary: '', detail: 'Record inserted successfully.' });
                }
            }
        });
    }
    bindHRBPDetailsList()
    {
        this.hrbpDataService.getHRBPDetails().subscribe((data) => {
            this.details = data;
        });
    }
    delete(id: number) {
        this.confirmationService.confirm({
            message: ' Are you sure, you want to delete this record?',
            accept: () => {
                this.hrbpDataService.deleteDetail(id).subscribe((returnedSyncValue: boolean) => {
                    this.synced = returnedSyncValue;
                    if (this.synced) {
                        this.msgs = [];
                        this.msgs.push({ severity: 'success', summary: '', detail: 'Record deleted successfully.' });
                        this.bindHRBPDetailsList();
                    }
                });
            }
        });
    }
    renamePropertyNames(json: any, _firstOption: any, _fieldForSave: any, _inputType: any) {

        let fieldForSave = "id";
        if (_fieldForSave) {
            if (_fieldForSave == "label") {
                fieldForSave = "name";
            }
        }

        var obj = JSON.parse(json);
        if (obj != null && obj != undefined && obj != '') {
            var objddl = [];

            if (_inputType != 'multiselect' && _firstOption != '') {
                objddl.push({ 'label': _firstOption, 'value': -1})
            }

            for (var i = 0; i < obj.length; i++) {
                if (obj[i].hasOwnProperty("name")) {
                    objddl.push({ 'label': obj[i]["name"], 'value': obj[i][fieldForSave] });
                }
            }
        }
        return objddl;
    }
}

class HRBPDetail implements IHRBPDetail
{
    constructor(public ID?: number,
        public Department?: any,
        public Location?: any,
        public DeliveryUnit?: any,
        public Client?: any,
        public Grade?: any,
        public HRBPs?: any,
        public ProjectGroup?: any,
        public Tenure?: any,
        public EmploymentStatus?: any,

        public ReviewPermission?: any,
        public TargetPermission?: any,
        public BenefitsPermission?: any,
        public AttendancePermission?: any


    ) {

    }
}



// WEBPACK FOOTER //
// ./src/app/Components/HRBusinessPartner/HRBPDetails.component.ts